module.exports = __webpack_public_path__ + "static/media/deductibleG.326d66fa.svg";